import React from "react";
import MetaData from "../../components/layout/MetaData";
import Title from "./Title";
import ContactDetails from "./ContactDetails";
import FormRequestQuote from "./FormRequestQuote";

/**
 * 渲染普通商品询价页面。
 */
export default function RequestQuotePage() {
  return (
    <>
      <MetaData title="Reqeust a Quote" />
      <div className="creatyea-padding get-a-quote-section">
        <div className="row">
          <div className="col-lg-8">
            <Title />
            <FormRequestQuote />
          </div>
          <ContactDetails />
        </div>
      </div>
    </>
  );
}
